import { render, staticRenderFns } from "./ItemCreateFast.vue?vue&type=template&id=c5a7c0b8"
import script from "./ItemCreateFast.vue?vue&type=script&lang=js"
export * from "./ItemCreateFast.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports